'use strict';

export default function () {
    return '<span class="aui-restfultable-throbber"></span>';
}
